module.exports = __webpack_public_path__ + "img/banner-自由练习.0848e542.png";